
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".5","width":"26","height":"26","rx":"13","fill":"#BAC1CA"}}),_c('path',{attrs:{"d":"M13 8.826a.75.75 0 00-.315.069l-8.322 3.84a.594.594 0 00-.02 1.07L7 15.155v2.595c0 .414.336.75.75.75h10.5a.75.75 0 00.75-.75v-2.596l1.5-.761v3.357a.751.751 0 101.5 0v-4.5h-.02a.585.585 0 00-.344-.514l-8.321-3.841A.751.751 0 0013 8.826z","fill":"#fff"}})])
          )
        }
      }
    